import equityChangesPayload from "@/payloads/equity_changes.json";

export default {
  loggedIn() {
    if (this.loggedIn) {
      this.$nextTick(() => {
        this.$refs.markets.data = this.markets;
        this.$refs.criteria.data = this.criteria;
        this.getLastSaturday();
        this.requestType = "equity";
        var payload = equityChangesPayload;
        payload["dateConditions"][0]["startDate"] = this.selectedDate;
        payload["dateConditions"][0]["endDate"] = this.todayDate;
        payload["dateConditions"][1]["startDate"] = this.selectedDate;
        payload["dateConditions"][1]["endDate"] = this.todayDate;
        this.postQueryExecution(payload);
      });
    }
  },
};
